import { Iframe } from '@alf/uikit';
import { useEncodedSearchParam } from '../../hooks/useEncodedSearchParam';

import styles from './index.module.css';

type Params = {
  src: string;
};

export const IframeProxy = <T extends Params>({ Component = Iframe }) => {
  const params = useEncodedSearchParam() as T;

  return <Component className={styles.root} {...params} />;
};
